import React from 'react';
import { Box, Avatar, Typography, CircularProgress } from '@mui/material';

const Loader = () => {
    const text = 'TRUCRED';
    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.6)',
                zIndex: 9999
            }}
        >
            <Box
                sx={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <CircularProgress
                    size={120}
                    thickness={4}
                    sx={{
                        color: '#1C2B4A',
                        animationDuration: '1.2s'
                    }}
                />
                <Avatar
                    sx={{
                        position: 'absolute',
                        width: 90,
                        height: 90,
                        background: 'linear-gradient(145deg, #6EC5FF, #A8E0FF)', // Light blue gradient

                        boxShadow: '0 4px 15px rgba(0, 255, 128, 0.3), inset 0 0 10px rgba(255, 255, 255, 0.1)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 600,
                        fontSize: '1rem',
                        letterSpacing: 1.5,
                        textTransform: 'uppercase',
                        color: '#ffffff',
                        textShadow: '0 0 6px #ffffff90'
                    }}
                >
                    {text.split('').map((char, index) => (
                        <Box
                            key={index}
                            component="span"
                            sx={{
                                animation: 'wave 1.5s infinite',
                                animationDelay: `${index * 0.1}s`,
                                display: 'inline-block'
                            }}
                        >
                            {char}
                        </Box>
                    ))}
                </Avatar>
            </Box>

            <style>
                {`
                    @keyframes wave {
                        0%, 100% { transform: translateY(0); }
                        50% { transform: translateY(-4px); }
                    }
                `}
            </style>
        </Box>
    );
};

export default Loader;
